const accountNavDirective = {
  restrict: 'A',
  link: function(link, el, attrs) {
    var $body = $('html, body');
    el.find('a').on('click', function(e) {
      e.preventDefault();
      $('.is-scrolled-to').removeClass('is-scrolled-to');
      var $this = $(this),
      section = $this.attr('href'),
      offset = $(section).offset();
      $this.addClass('is-scrolled-to');
      $body.animate({ scrollTop: offset.top });
    });
  }
};

export default accountNavDirective;



// WEBPACK FOOTER //
// ./js/containers/dashboard/directives/accountNav.js